import React, { createContext, useContext } from "react";

const CurrencyFormatContext = createContext();

export const useCurrencyFormat = () => useContext(CurrencyFormatContext);

export const CurrencyFormatProvider = ({ currencyFormat, children }) => (
  <CurrencyFormatContext.Provider value={currencyFormat}>
    {children}
  </CurrencyFormatContext.Provider>
);
